var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-card"
  }, [_c("section", {
    staticClass: "card-panel",
    class: {
      "panel-right": _vm.isReverse
    }
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))]), _c("section", {
    staticClass: "desc"
  }, _vm._l(_vm.paragraph, function (item, index) {
    return _c("p", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c("section", {
    staticClass: "card-img",
    class: {
      "img-left": _vm.isReverse
    }
  }, [_c("img", {
    attrs: {
      src: require(`@/assets/images/service/self-select-stock/${_vm.img}`),
      alt: ""
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };